// extracted by mini-css-extract-plugin
export default {"addToDoForm":"AddTodoForm_addToDoForm__6jkpy","button":"AddTodoForm_button__OYGwG"};